/**
 * Clinic-local calendar date (Europe/Kyiv) for a given instant, as YYYY-MM-DD.
 * Promo ranges are Kyiv-local dates (SPRINT_9_PLAN §3.6): "діє до 31.08" means
 * the clinic's Aug 31 regardless of the server's TZ.
 */
const kyivFmt = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Europe/Kyiv",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

export function kyivDateISO(at: Date): string {
  return kyivFmt.format(at);
}

const dateTimeFmt = new Intl.DateTimeFormat("uk-UA", {
  timeZone: "Europe/Kyiv",
  weekday: "short",
  day: "numeric",
  month: "long",
  hour: "2-digit",
  minute: "2-digit",
});

/** "чт, 2 жовтня о 10:00" — the clinic's local wall time with the weekday (the Mini App's lists). */
export function kyivDateTimeLabel(at: Date): string {
  return dateTimeFmt.format(at);
}

const whenFmt = new Intl.DateTimeFormat("uk-UA", {
  timeZone: "Europe/Kyiv",
  day: "numeric",
  month: "long",
  hour: "2-digit",
  minute: "2-digit",
});

/** "2 жовтня о 10:00" — the same instant for a message to the patient (Telegram, email). */
export function kyivWhenLabel(at: Date): string {
  return whenFmt.format(at);
}
